import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { APP_NAME } from '../../config/constants';
interface WelcomeScreenProps {
  onLoadDemo: () => void;
}
export function WelcomeScreen({
  onLoadDemo
}: WelcomeScreenProps) {
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 flex items-center justify-center p-4 md:p-8" data-id="element-1307">
      <div className="w-full max-w-2xl" data-id="element-1308">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-1309">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-3xl shadow-2xl shadow-indigo-200 mb-6 transform rotate-3 hover:rotate-6 transition-transform" data-id="element-1310">
            <span className="text-white font-black text-4xl" data-id="element-1311">M</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-4 tracking-tight" data-id="element-1312">
            Welkom bij {APP_NAME}!
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 font-medium max-w-2xl mx-auto mb-8" data-id="element-1313">
            Laad demo accounts om de app te verkennen
          </p>

          {/* Demo Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-1314">
            <Card className="inline-block p-8 bg-white border-2 border-amber-200 shadow-2xl" data-id="element-1315">
              <div className="flex flex-col items-center gap-6" data-id="element-1316">
                <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center shadow-md" data-id="element-1317">
                  <Sparkles className="w-8 h-8 text-amber-600" data-id="element-1318" />
                </div>

                <div className="text-center" data-id="element-1319">
                  <p className="font-black text-slate-900 mb-2 text-2xl" data-id="element-1320">
                    Demo Accounts
                  </p>
                  <p className="text-slate-600 mb-6 max-w-md" data-id="element-1321">
                    Ontdek de app met voorbeeldaccounts voor leerling, ouder,
                    docent en beheerder, compleet met realistische voortgang
                  </p>
                </div>

                <Button variant="primary" size="xxl" onClick={onLoadDemo} className="shadow-xl hover:shadow-2xl transition-shadow" data-id="element-1322">
                  <Sparkles className="w-5 h-5 mr-2" data-id="element-1323" />
                  Demo Accounts Laden
                </Button>
              </div>
            </Card>
          </motion.div>
        </motion.div>

        {/* Info Cards */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12" data-id="element-1324">
          <Card className="p-4 bg-indigo-50 border-indigo-200" data-id="element-1325">
            <div className="text-center" data-id="element-1326">
              <div className="text-3xl mb-2" data-id="element-1327">👨‍🎓</div>
              <p className="font-bold text-indigo-900 text-sm" data-id="element-1328">5 Leerlingen</p>
              <p className="text-xs text-indigo-700" data-id="element-1329">
                Djayden, Emma, Noah, Sophie &amp; Liam
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-emerald-50 border-emerald-200" data-id="element-1330">
            <div className="text-center" data-id="element-1331">
              <div className="text-3xl mb-2" data-id="element-1332">👪</div>
              <p className="font-bold text-emerald-900 text-sm" data-id="element-1333">2 Ouders</p>
              <p className="text-xs text-emerald-700" data-id="element-1334">
                Mama &amp; Papa van Noah
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-violet-50 border-violet-200" data-id="element-1335">
            <div className="text-center" data-id="element-1336">
              <div className="text-3xl mb-2" data-id="element-1337">👨‍🏫</div>
              <p className="font-bold text-violet-900 text-sm" data-id="element-1338">2 Docenten</p>
              <p className="text-xs text-violet-700" data-id="element-1339">
                Meester Jay &amp; Juf Lisa
              </p>
            </div>
          </Card>

          <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-1340">
            <div className="text-center" data-id="element-1341">
              <div className="text-3xl mb-2" data-id="element-1342">🛡️</div>
              <p className="font-bold text-amber-900 text-sm" data-id="element-1343">Admin</p>
              <p className="text-xs text-amber-700" data-id="element-1344">Globaal beheer</p>
            </div>
          </Card>
        </motion.div>

        {/* Footer */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="text-center mt-12" data-id="element-1345">
          <p className="text-sm text-slate-500" data-id="element-1346">
            Alle gegevens worden lokaal opgeslagen in je browser
          </p>
        </motion.div>
      </div>
    </div>;
}